import { onMounted, ref } from 'vue';

const leavePage = (pageTimeout, enabled) => {
    pageTimeout.value = setTimeout(() => {
        if (enabled.value) {
            document.title = 'Vergeet je Keuze niet! 👋';
        }
    }, 20000);
};

const comesBackToPage = (pageTimeout) => {
    clearTimeout(pageTimeout.value);
    document.title = document.initialTitle;
};

export function useWindowBlurTitle(enabled) {
    const pageTimeout = ref(null);

    onMounted(() => {
        document.initialTitle = document.title;
        window.addEventListener('blur', () => {
            leavePage(pageTimeout, enabled);
        });
        window.addEventListener('focus', () => {
            comesBackToPage(pageTimeout);
        });
    });
}
